import { memo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Footer from './Footer';
import HeroSection from './sections/HeroSection';
import VideoSection from './sections/VideoSection';
import UserChatsSection from './sections/UserChatsSection';
import AgentChatsSection from './sections/AgentChatsSection';
import ExamplesSection from './sections/ExamplesSection';
import PricingSection from './sections/PricingSection';
import CTASection from './sections/CTASection';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleOneTapAuth from './GoogleOneTapAuth';
import SmoothScroll from '../common/SmoothScroll';

import styles from './styles/Home.module.css';

const WAITLIST_PHASE = false;

const Home = () => {
  const { isAuthenticated } = useAuth();
  const [loadingStage, setLoadingStage] = useState(0); // 0: VideoSection, 1: UserChats, 2: AgentChats

  return (
    <SmoothScroll>
      <div className={styles.container}>
        <header className={styles.header}>
          <Link to="/">
            <img
              src="/icons/android-icon-192x192.png"
              alt="JetChats Logo"
              className={styles.logo}
            />
          </Link>

          {isAuthenticated === true && (
            <Link to="/chats" className={styles.ctaButton}>
              Go to app
            </Link>
          )}
          {isAuthenticated === false && (
            <div className={styles.headerButtons}>
              <Link to="/login" className={styles.loginButton}>
                Log in
              </Link>
              {/* WAITLIST_PHASE */}
              {WAITLIST_PHASE === true ? (
                <Link to="/waitlist" className={styles.ctaButton}>
                  Join waitlist
                </Link>
              ) : (
                <Link to="/register" className={styles.ctaButton}>
                  Join for free
                </Link>
              )}
              {/* Google One Tap Authentication */}
              {WAITLIST_PHASE === false ? (
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                  <GoogleOneTapAuth />
                </GoogleOAuthProvider>
              ) : null}
            </div>
          )}
        </header>

        <main className={styles.main}>
          <HeroSection />
          <VideoSection onLoadComplete={() => setLoadingStage(prev => Math.max(prev, 1))} />
          <UserChatsSection
            shouldLoad={loadingStage >= 1}
            onLoadComplete={() => setLoadingStage(prev => Math.max(prev, 2))}
          />
          <AgentChatsSection shouldLoad={loadingStage >= 2} />
          <ExamplesSection />
          <PricingSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default memo(Home);
